import { createTranslationRef, createTranslationResource } from '@backstage/core-plugin-api/alpha';

export const entityPageTranslationRef = createTranslationRef({
  id: 'entity-page',
  messages: {
    root: {
      search: 'Search',
      catalog: 'Catalog',
      docs: 'Docs',
      create: 'Create...',
    },
    loginPage: {
      title: "Welcome to the Internal Developer Portal (IDP) of Acciona",
      subtitle: "To access the platform, please log in with your corporate email",
    },
    homePage: {
      selfServiceTitle: 'Self - Service HUB',
      selfServiceError: 'Error loading self-service items',
      catalogTitle: 'Catalogs',
      catalogError: 'Error loading catalog items',
      toolkitTitle: 'Toolkits',
      comingSoon: 'Coming Soon...',
      home: 'Home',
    },
    approvalButton: {
      buttonContent: 'Approve and Provision',
      buttonDenyContent: 'Deny Request',
      buttonProvisioningFailedContent: 'Provision',
      warningMessage: 'This component is of type request. It is necessary to approve it to start the provisioning process.',
      provisioningFailedMessage: 'The component is approved but the provisioning process failed. Please resolve the problems and try again.',

      "successMessage": "Approval started successfully. Reloading...",
      "errorMessage": "Approval error: {{error}}",
      "unknownError": "Unknown error",
      "connectionError": "Connection error while processing the approval",
      "loadingMessage": "Processing approval...",
    },
    cicdContent: {
      configEditorEnvironment: 'Environment',
      configEditorType: 'Configuration Type',
      configEditorLoadConfigButton: 'View Config',
      configEditorSaveConfigButton: 'Save CI Config',
      configEditorSaveCdConfigButton: 'Save CD Config for environment:',
      configEditorAddCdTemplateButton: 'Add CD Template',
      configEditorAddCdTemplateEnvironment: 'Add CD Template for this environment',
      configEditorCdEnvironmentConfigured: 'Configured',
      configEditorCdEnvironmentNotConfigured: 'Not Configured',
      configEditorRepoLegacyMessage: 'This repository uses the legacy configuration method and needs to be migrated to the new configuration.',
      configEditorCINotConfiguredMessage: 'No CI configuration found. Please add a CI template.',
      configEditorCDNotConfiguredMessage: 'No CD configuration found. Please add a CD template for an environment.',
      configEditorLoadingConfigMessage: 'Loading config...',
      configEditorUserDontHavePermissions: 'You don\'t have permissions to access this configuration.',

      "successLoadConfigMessage": "Config loaded successfully",
      "successSaveConfigMessage": "Config saved successfully",
      "loadingConfigMessage": "Loading config...",
      "loadingSaveConfigMessage": "Saving config...",
      "noConfigExistsMessage": "Configuration not found. Please fill in the form and save the configuration.",
    }
  },
});

export const entityPageTranslations = createTranslationResource({
  ref: entityPageTranslationRef,
  translations: {
    en: () => import('./entity-page-en'),
    es: () => import('./entity-page-es'),
  },
});